jQuery(function () {
    var header = jQuery(".site-header");
    var html = jQuery("html");
    jQuery(window).scroll(function () {
        var scroll = jQuery(window).scrollTop();
        if (scroll >= 100) {
            header.addClass("obs-floatingNav");
            html.addClass("has-scrolled-down");
        }
        else {
            header.removeClass("obs-floatingNav");
            html.removeClass("has-scrolled-down");
        }
    });
});
